import * as R from 'remeda';
import { combineEpics } from 'redux-observable';
import {
  filter,
  first,
  map,
  mapTo,
  pluck,
  skip,
  switchMap,
} from 'rxjs/operators';
import { isEmbedded } from '../../../constants/config';
import {
  annotationExpired,
  deleteAnnotationFulfilled,
  postponeAnnotationFulfilled,
  rejectAnnotation,
  rejectAnnotationFulfilled,
} from '../annotation/actions';
import { deleteAnnotations, postponeAnnotations } from '../annotations/actions';
import { createDatapointsFulfilled } from '../datapoints/actions';
import { updateUserFulfilled } from '../user/actions';
import { isActionOf, makeEpic } from '../utils';
import { throwError, throwInfo } from './actions';

const showDeleteInformationEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(deleteAnnotations)),
    switchMap(({ meta: { urls } }) =>
      action$.pipe(
        filter(isActionOf(deleteAnnotationFulfilled)),
        pluck('meta', 'withMessage'),
        filter(withMessage => withMessage),
        skip(urls.length - 1),
        first(),
        filter(() => !isEmbedded()),
        map(() => throwInfo('annotationDeleted', { count: urls.length }))
      )
    )
  )
);

const showPostponeInformationEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(postponeAnnotations)),
    switchMap(({ meta: { urls } }) =>
      action$.pipe(
        filter(isActionOf(postponeAnnotationFulfilled)),
        pluck('meta', 'withMessage'),
        filter(withMessage => withMessage),
        skip(urls.length - 1),
        first(),
        filter(() => !isEmbedded()),
        map(() => throwInfo('annotationPostponed', { count: urls.length }))
      )
    )
  )
);

const showRejectInformationEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(rejectAnnotation)),
    switchMap(() =>
      action$.pipe(
        filter(isActionOf(rejectAnnotationFulfilled)),
        pluck('meta', 'withMessage'),
        filter(withMessage => !!withMessage),
        filter(() => !isEmbedded()),
        map(() => throwInfo('rejectAnnotation', { count: 1 }))
      )
    )
  )
);

export const showDatapointsEmptyResponseEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(createDatapointsFulfilled)),
    pluck('payload', 'content'),
    filter(content => !content.length),
    mapTo(throwError('operationTimeout'))
  )
);

const showExpirationInformationEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(annotationExpired)),
    mapTo(throwInfo('timeOut', undefined, { isPersistent: true }))
  )
);

const userDetailUpdatedEpic = makeEpic(action$ =>
  action$.pipe(
    filter(isActionOf(updateUserFulfilled)),
    pluck('meta', 'withMessage'),
    filter(R.isTruthy),
    mapTo(throwInfo('userUpdated'))
  )
);

export default combineEpics(
  showDatapointsEmptyResponseEpic,
  showDeleteInformationEpic,
  showExpirationInformationEpic,
  showPostponeInformationEpic,
  showRejectInformationEpic,
  userDetailUpdatedEpic
);
